import { useState } from "react";
import React from "react";
import { I_Plus } from "./icons";
import { Spinner } from "./ui";
import { logActivity } from "../lib/activity.js";
import { todayISO } from "../lib/format.js";
import { btnG, btnP, glassDeep, heading, input } from "../styles.js";
import { sb } from "../supabase.js";

const QuickCreate = ({ kind, session, onClose, onCreated }) => {
    const [v, setV] = useState("");
    const [busy, setBusy] = useState(false);
    const save = async () => {
      if (!v.trim()) return;
      setBusy(true);
      const tbl = kind === "client" ? "clients" : "properties";
      const row =
        kind === "client"
          ? {
              name: v.trim(),
              request_date: todayISO(),
              created_by: session.user.id,
            }
          : {
              title: v.trim(),
              created_by: session.user.id,
            };
      const { data, error } = await sb.from(tbl).insert(row).select().single();
      if (!error) {
        logActivity(session.user.id, "created", kind, data.id, `Created new ${kind}: ${v.trim()}`);
        onCreated(data.id);
        onClose();
      } else {
        alert("Couldn't create: " + error.message);
      }
      setBusy(false);
    };
    return (
      <React.Fragment>
        <div className="fixed inset-0 bg-slate-950/60 backdrop-blur-sm z-50" onClick={onClose} />
        <div
          className={`fixed left-1/2 top-32 -translate-x-1/2 w-[92vw] max-w-md z-[55] ${glassDeep} rounded-2xl shadow-2xl p-5`}
        >
          <h3 className="text-xl text-slate-100 mb-3" style={heading}>
            New {kind}
          </h3>
          <input
            autoFocus={true}
            value={v}
            onChange={(e) => setV(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && save()}
            placeholder={kind === "client" ? "Client name" : "Property title"}
            className={input}
          />
          <p className="text-xs text-slate-400 mt-2">Add the rest in the next screen.</p>
          <div className="flex justify-end gap-2 mt-4">
            <button onClick={onClose} className={btnG}>
              Cancel
            </button>
            <button
              onClick={save}
              disabled={busy || !v.trim()}
              className={`${btnP} disabled:opacity-50`}
            >
              {busy ? <Spinner size={13} /> : <I_Plus size={13} />}Create
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  };

export { QuickCreate };
